module.exports = __webpack_public_path__ + "static/media/wizualizacja-122.9b38080c.png";